export class LpSummaryModel {

    public id: number;
    public shortName: string;
    public unp: string;
    public email: string;
    public phone: string;
    public countryId: number;

    constructor(obj?: any) {
        this.id                 = obj && obj.id                 || null;
        this.shortName          = obj && obj.shortName          || '';
        this.unp                = obj && obj.unp                || '';
        this.email              = obj && obj.email              || '';
        this.phone              = obj && obj.phone              || '';
        this.countryId          = obj && obj.countryId          || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/lp-summary.model.ts